import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78e2d8c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inline-block d-flex mb-0 w-100 justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "form-label text-center fs-1 nav-link" }, " Configurações ")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex mb-0 w-100 justify-content-center fundo" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "form-label text-center fs-3 nav-link" }, " Cliente ")
], -1))
const _hoisted_3 = { class: "form-label col-sm-12 col-md-12 mb-2" }
const _hoisted_4 = { class: "form-label col-sm-12 col-md-12 mb-2" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "form-label col-sm-12 col-md-12 mb-2" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "form-label col-sm-12 col-md-12 mb-2" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "form-label col-sm-12 col-md-12 mb-2" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "form-label col-sm-12 col-md-12 mb-2" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "form-label col-sm-12 col-md-12 mb-2" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, null, -1))
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "form-label col-sm-12 col-md-12 mb-2" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { class: "form-label col-sm-12 col-md-12 mb-2" }
const _hoisted_26 = { class: "w-100 d-flex justify-content-end pe-4" }

import { TipoMensagem } from '@/consts/consts';
import mensagem from '@/hooks/mensagem';
import Config from '@/model/Config';
import services from '@/services';
import { store } from '@/store';
import { onMounted, reactive } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Config',
  props: ['maiusculo', 'retornaPossuiPermissao', 'retornaDataBR', 'retornaIdVDatePicker', 'retornaDataUSA'],
  setup(__props) {

const props = __props;


const state = reactive({
    config: Object() as Config,
    usarEnfermeiro: Boolean(),
    telaPequena: Boolean(),
    /*
    prontCampoEnf
    prontCampoEnfVisible
    */
});

function tamanho() {
    setInterval(() => {
        // (window.innerWidth <= 992) ? state.telaPequena = true : state.telaPequena = false;
        (window.innerWidth <= 1023) ? state.telaPequena = true : state.telaPequena = false;
    }, 100);
}

async function salvarAlteracoes() {
    const { data, erros } = await services.config.Alterar(state.config);
    if (!erros) {
        store.commit('setConfig', state.config);
        const msg = mensagem();
        msg.InserirMensagem('Sucesso', "Config alterado com sucesso", TipoMensagem.Information);
    } else {
        const msg = mensagem();
        msg.InserirMensagem('Erro', erros.statusText, TipoMensagem.Error);
    }
}

onMounted(async () => {
    const { data, erros } = await services.config.Listar();
    if (!erros) {
        state.config = data;
    }
    tamanho();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["content-page", { ' mt-4': state.telaPequena == true }])
  }, [
    _hoisted_1,
    _createElementVNode("div", {
      class: _normalizeClass(["mt-1 border scrollspy-example p-2", { 'ms-4 w-25': state.telaPequena == false, 'row px-3 mx-2': state.telaPequena == true }]),
      style: {"min-height":"680px"}
    }, [
      _hoisted_2,
      _createElementVNode("label", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          class: "form-check-input",
          type: "checkbox",
          name: "",
          id: "",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.config.prontCampoUnico) = $event))
        }, null, 512), [
          [_vModelCheckbox, state.config.prontCampoUnico]
        ]),
        _createTextVNode(" Prontuário campo único ")
      ]),
      _createElementVNode("label", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          class: "form-check-input",
          type: "checkbox",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.config.prontCampo1Visible) = $event)),
          name: "",
          id: ""
        }, null, 512), [
          [_vModelCheckbox, state.config.prontCampo1Visible]
        ]),
        _createTextVNode(" Descrição campo 1 "),
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          type: "text",
          placeholder: "HDA Médico",
          disabled: state.config.prontCampo1Visible == false,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((state.config.prontCampo1) = $event))
        }, null, 8, _hoisted_5), [
          [_vModelText, state.config.prontCampo1]
        ])
      ]),
      _createElementVNode("label", _hoisted_6, [
        _withDirectives(_createElementVNode("input", {
          class: "form-check-input",
          type: "checkbox",
          disabled: state.config.prontCampoUnico != false,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((state.config.prontCampo2Visible) = $event)),
          name: "",
          id: ""
        }, null, 8, _hoisted_7), [
          [_vModelCheckbox, state.config.prontCampo2Visible]
        ]),
        _createTextVNode(" Descrição campo 2 "),
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          type: "text",
          placeholder: "Exame Físico",
          disabled: state.config.prontCampo2Visible == false,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((state.config.prontCampo2) = $event))
        }, null, 8, _hoisted_8), [
          [_vModelText, state.config.prontCampo2]
        ])
      ]),
      _createElementVNode("label", _hoisted_9, [
        _withDirectives(_createElementVNode("input", {
          class: "form-check-input",
          type: "checkbox",
          disabled: state.config.prontCampoUnico != false,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((state.config.prontCampo3Visible) = $event)),
          name: "",
          id: ""
        }, null, 8, _hoisted_10), [
          [_vModelCheckbox, state.config.prontCampo3Visible]
        ]),
        _createTextVNode(" Descrição campo 3 "),
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          type: "text",
          placeholder: "Diagnóstico",
          disabled: state.config.prontCampo3Visible == false || state.config.prontCampoUnico != false,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((state.config.prontCampo3) = $event))
        }, null, 8, _hoisted_11), [
          [_vModelText, state.config.prontCampo3]
        ])
      ]),
      _createElementVNode("label", _hoisted_12, [
        _withDirectives(_createElementVNode("input", {
          class: "form-check-input",
          type: "checkbox",
          disabled: state.config.prontCampoUnico != false,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((state.config.prontCampo4Visible) = $event)),
          name: "",
          id: ""
        }, null, 8, _hoisted_13), [
          [_vModelCheckbox, state.config.prontCampo4Visible]
        ]),
        _createTextVNode(" Descrição campo 4 "),
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          type: "text",
          placeholder: "Receita",
          disabled: state.config.prontCampo4Visible == false || state.config.prontCampoUnico != false,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((state.config.prontCampo4) = $event))
        }, null, 8, _hoisted_14), [
          [_vModelText, state.config.prontCampo4]
        ])
      ]),
      _createElementVNode("label", _hoisted_15, [
        _withDirectives(_createElementVNode("input", {
          class: "form-check-input",
          type: "checkbox",
          disabled: state.config.prontCampoUnico != false,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((state.config.prontCampo5Visible) = $event)),
          name: "",
          id: ""
        }, null, 8, _hoisted_16), [
          [_vModelCheckbox, state.config.prontCampo5Visible]
        ]),
        _createTextVNode(" Descrição campo 5 "),
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          type: "text",
          placeholder: "Receita Especial",
          disabled: state.config.prontCampo5Visible == false || state.config.prontCampoUnico != false,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((state.config.prontCampo5) = $event))
        }, null, 8, _hoisted_17), [
          [_vModelText, state.config.prontCampo5]
        ])
      ]),
      _createElementVNode("label", _hoisted_18, [
        _createTextVNode(" Campo obrigatório "),
        _withDirectives(_createElementVNode("select", {
          class: "form-select",
          name: "",
          id: "",
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((state.config.prontCampoIndice) = $event)),
          disabled: state.config.prontCampoUnico != false
        }, [
          _hoisted_20,
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (item, index) => {
            return _createElementVNode("option", {
              value: item,
              key: index
            }, _toDisplayString(item), 9, _hoisted_21)
          }), 64))
        ], 8, _hoisted_19), [
          [_vModelSelect, state.config.prontCampoIndice]
        ])
      ]),
      _createElementVNode("label", _hoisted_22, [
        _withDirectives(_createElementVNode("input", {
          class: "form-check-input",
          type: "checkbox",
          disabled: state.config.prontCampoUnico != false,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((state.config.prontCampoEnfVisible) = $event)),
          name: "",
          id: ""
        }, null, 8, _hoisted_23), [
          [_vModelCheckbox, state.config.prontCampoEnfVisible]
        ]),
        _createTextVNode(" Campo Enfermagem "),
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          type: "text",
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((state.config.prontCampoEnf) = $event)),
          placeholder: "HDA Enfermagem",
          disabled: state.config.prontCampoEnfVisible == false || state.config.prontCampoUnico != false
        }, null, 8, _hoisted_24), [
          [_vModelText, state.config.prontCampoEnf]
        ])
      ]),
      _createElementVNode("label", _hoisted_25, [
        _withDirectives(_createElementVNode("input", {
          class: "form-check-input",
          type: "checkbox",
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((state.config.usarAgenda) = $event)),
          disabled: true
        }, null, 512), [
          [_vModelCheckbox, state.config.usarAgenda]
        ]),
        _createTextVNode(" Usar Agenda ")
      ])
    ], 2),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("button", {
        class: "btn btn-primary",
        onClick: _cache[15] || (_cache[15] = ($event: any) => (salvarAlteracoes()))
      }, "Salvar")
    ])
  ], 2))
}
}

})